/* eslint-disable no-invalid-this,sonarjs/function-return-type */
import yup from '@/libs/yup';

export default yup.object({
    value_type: yup
        .string()
        .oneOf(['string', 'enum', 'bool', 'number', 'json'])
        .required(),
    value: yup
        .mixed()
        .test('validate-value', 'Invalid value', function (value) {
            if (this.parent.value_type === 'json') {
                if (typeof value !== 'string') return false;
                try {
                    JSON.parse(value);
                    return true;
                } catch {
                    return this.createError({
                        message: 'Value must be a valid JSON string'
                    });
                }
            }

            if (this.parent.value_type === 'enum' && !value) {
                return this.createError({
                    message: 'Value is required'
                });
            }

            return true;
        })
});
